/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react'
import Header from './components/Header'
import MainFields from './components/MainFields'
import Footer from './components/Footer'
import { GetOrderDetailsByOrderId } from '../../hooks/fetch-hooks/order-details.js/get-order-details-by-id'
import moment from 'moment/moment'
import PrescriptionItems from './prescription-items'
import { useNavigate, useNavigation, useParams, useSearchParams } from 'react-router-dom';
import { UpdateOrder } from '../../hooks/update-hooks/edit-order/order-data-update'
import { UpdatePrescriptionItem } from '../../hooks/update-hooks/prescription-item/update-prescription-item'
import { AddPrescriptionItem } from '../../hooks/update-hooks/prescription-item/add-prescription-item'
import { DeletePrescriptionItem } from '../../hooks/update-hooks/prescription-item/delete-prescription-item'
import { UpdatePrescription } from '../../hooks/update-hooks/prescription/update-prescription'
import { isNil } from 'lodash'
import PaymentsTable from '../../components/PaymentsTable'
import { getOrderPayableTotal } from '../../components/PaymentsTable/helper'
import Loader from '../../components/Loader'
import ItemSubstitutes from '../../components/ItemSubstitutes'
import Cookies from 'js-cookie';
import { TENANT_COMPANY_MAP, ORDER_CANCELLED } from '../../utils/constants'
import { request } from '../../config/helpers/axios-instance'
import { toast } from 'react-toastify'
import { useSourcesData } from '../../hooks/fetch-hooks/get-sources'
import { GetPartners } from '../../hooks/fetch-hooks/partners/get-partners'
import { paymentStatus } from '../../components/PaymentsTable/constants'
import utils from '../../utils/utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import PaymentsItemsTable from '../../components/PaymentsItemsTable/PaymentsItemTable'
import { getTenantId } from '../../utils/helpers';
import RefundsTable from '../../components/RefundsTable/RefundsTable';
import GetRefundsByOrderId from '../../hooks/fetch-hooks/get-refund-by-orderId/get-refunds-by-order-id';
import DrugInteractionPanel from './components/DrugInteractionPanel';
import PreShipmentChecklist from './components/PreShipmentChecklist';
import InvoiceRxCheckPanel from './components/InvoiceRxCheckPanel';
import { getMedicineQuantity } from '../../utils/generateRows';
import OrderScreenshot from './components/OrderScreenshot';
import OrderHistory from './components/OrderHistory';

export default function EditOrder() {
    const { orderId } = useParams()
    const { data, isFetched, refetch } = GetOrderDetailsByOrderId(orderId);
    const autoFilledRowIds = useRef(new Set())
    const [orderData, setOrderData] = useState(null)
    const [userData, setuserData] = useState(null);
    const tenantId = getTenantId();
    const { getSourcesForChannels } = useSourcesData();
    const { data: partnerData, isLoading: partnersLoading } = GetPartners(null, '');
    const [partners, setPartners] = useState([]);
    const navigate = useNavigate()
    const isEasydose = process.env.REACT_APP_EASYDOSE_FEATURE_ENABLED === 'true' && tenantId === TENANT_COMPANY_MAP.EAZY;
    const isPillupTenant = tenantId === TENANT_COMPANY_MAP.PILLUP;

    const handleBackClick = () => {
        navigate(-1);
    }

    const {
        data: refundsData,
        isLoading: refundsLoading,
        refetch: refetchRefunds,
    } = GetRefundsByOrderId(orderId);

    const refunds = refundsData?.data?.data || [];

    // Calculate total payments (SUCCESS and PENDING)
    const calculateTotalPayments = (orderData) => {
        return utils.roundOffPaymentAmount(orderData?.payments?.reduce((total, payment) => {
            if (payment.status === paymentStatus.SUCCESS) {
                return total + parseFloat(payment.amount || 0);
            }
            return total;
        }, 0));
    };

    useEffect(() => {
        if (partnerData) {
            setPartners(partnerData.data.data.rows.map((partner) => ({
                id: partner.id,
                name: partner.name
            })));
        }
    }, [partnerData]);

    useEffect(() => {
        let resOrderData = data?.data?.data;
        let prescriptionItems = {}
        const autoFillSaves = []
        resOrderData?.prescription?.prescriptionItems.map((item) => {
            let initialAPiCallPayLoadData = {};
            item.isValidStartdate = true;
            item.isValidEndDate = true;
            item.isValidDuration = true;
            if (!item.startDate) {
                initialAPiCallPayLoadData['startDate'] = moment(resOrderData?.startDate).format('YYYY-MM-DD');
            }
            if (!item.endDate) {
                initialAPiCallPayLoadData['endDate'] = moment(resOrderData?.endDate).format('YYYY-MM-DD');
            }
            if (!item.duration) {
                initialAPiCallPayLoadData['duration'] = resOrderData?.noOfDays
            }
            if (!item.doseSize) {
                initialAPiCallPayLoadData['doseSize'] = 1;
            }
            if (!item.typeOfAdmin) {
                initialAPiCallPayLoadData['typeOfAdmin'] = 'DAYS'
            }
            if (!item.meal) {
                initialAPiCallPayLoadData['meal'] = []
            }
            if (!item.time) {
                initialAPiCallPayLoadData['time'] = []
            }
            const autoFillSave = initialDataUpdate(item.id, initialAPiCallPayLoadData)
            if (autoFillSave) autoFillSaves.push(autoFillSave)
            prescriptionItems[item.id] = item;
        })
        // Refetch once, after the saves land, so the page shows what they wrote.
        if (autoFillSaves.length > 0) Promise.all(autoFillSaves).then(() => refetch())

        if (data) {
            const payableTotal = getOrderPayableTotal({
                paymentItems: resOrderData?.paymentItems,
                orderTotal: resOrderData?.total,
            });
            const totalPayments = calculateTotalPayments(resOrderData);

            setOrderData({
                chronicity: resOrderData.chronicity,
                prescription: resOrderData.prescription,
                prescriptionItems: prescriptionItems,
                startDate: moment(resOrderData?.startDate).format('YYYY-MM-DD'),
                endDate: moment(resOrderData?.endDate).format('YYYY-MM-DD'),
                noOfDays: resOrderData?.noOfDays,
                drName: resOrderData?.prescription?.drName,
                date: resOrderData?.prescription?.date,
                messages: resOrderData?.messages || [],
                status: resOrderData?.status,
                prescriptionId: parseInt(resOrderData?.prescriptionId),
                notes: resOrderData?.notes,
                // Carries `extraItems` (the Add Extra Items modal) alongside `billNumber`
                // and whatever else writes here -- passed through whole, never rebuilt.
                additionalDetails: resOrderData?.additionalDetails || {},
                userTimings: resOrderData?.mapUserPatient?.Patient?.userDetail?.timings,
                mappingId: resOrderData?.mapUserPatient?.id,
                payments: resOrderData?.payments,
                paymentItems: resOrderData?.paymentItems,
                quotationId: resOrderData?.quotation?.id || null,
                total: resOrderData?.total,
                payableTotal,
                totalPayments,
                isFullyPaid: totalPayments >= payableTotal,
                id: resOrderData?.id,
                addressId: resOrderData?.addressId,
                address: resOrderData?.address,
                inventoryId: resOrderData?.inventoryId,
                mapUserPatient: resOrderData?.mapUserPatient,
                // isEditable: !calculateTotalPayments(resOrderData) >= parseFloat(resOrderData?.total || 0),
                // Currently we are allowing to edit the order even if it is fully paid
                isEditable: true,
                type: resOrderData?.type,
                source: resOrderData?.source,
                channel: resOrderData?.channel,
                itemSubstitutes: resOrderData?.itemSubstitutes || [],
                partnerId: resOrderData?.partnerId,
                metadata: resOrderData?.metadata || {}
            })
            setuserData({
                User: resOrderData?.mapUserPatient.User,
                Patient: resOrderData?.mapUserPatient.Patient,
                prescription: resOrderData?.prescription,
                evitalRx: resOrderData?.inventoryData?.print_url || "",
                address: resOrderData?.address,
                mappingId: resOrderData?.mapUserPatient.id,
                id: resOrderData?.id,
            })
        }
    }, [data])

    if (!isFetched) {
        return (
            <div className="flex items-center justify-center h-full">
                <Loader size="large" text="Loading order details..." />
            </div>
        )
    }

    const fetchBillNumber = async () => {
        try {
            const response = await request({
                method: "POST",
                url: `userOrder/admin/fetchBillNumber/${orderId}`,
            });
            if (response?.data?.success) {
                toast.success(`Bill number fetched: ${response.data.data.billNumber}`);
                refetch();
            } else {
                toast.error(response?.data?.err || "Failed to fetch bill number");
            }
        } catch {
            toast.error("Something went wrong");
        }
    };

    // Each row gets one attempt per page load. A save that leaves a field empty (say the order has
    // no noOfDays to copy) would otherwise save and refetch forever, and every refetch spends one
    // eVital orders/view call: order 26054 used up the hourly limit that way on 2026-11-05.
    function initialDataUpdate(id, payLoadData) {
        if (Object.keys(payLoadData).length === 0 || autoFilledRowIds.current.has(id)) return null
        autoFilledRowIds.current.add(id)
        return UpdatePrescriptionItem(id, payLoadData).catch((err) => { console.log(err) })
    }
    /**
     * Scroll a prescriptionItem into view
     * @param {*} id 
     */
    const scrollToPrescriptionItemById = (id) => {
        setTimeout(() => {
            const section = document.querySelector(`#prescriptionItem-${id}`);
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 200)
    }

    /**
     * Handles the change of start date or the duration for the order being edited 
     * @param {*} newStartDate 
     * @param {*} newDuration 
     */
    function handleOrderStartDateOrDurationChange(newOrderStartDate = null, newOrderNoOfDays = null, orderData) {
        if (newOrderStartDate === null) newOrderStartDate = moment(orderData.startDate, 'YYYY-MM-DD');
        if (newOrderNoOfDays === null) newOrderNoOfDays = moment(newOrderStartDate).add(orderData.noOfDays - 1, 'days').diff(moment(newOrderStartDate), 'days') + 1;

        let prevOrderStartDate = moment(orderData?.startDate, 'YYYY-MM-DD');
        let prevOrderNoOfDays = parseInt(orderData?.noOfDays);

        let prevPrescriptionItems = JSON.parse(JSON.stringify(orderData?.prescriptionItems));

        for (let id in prevPrescriptionItems) {
            let prescriptionItem = prevPrescriptionItems[id];

            let prevRxItemStartDate = moment(prescriptionItem?.startDate, 'YYYY-MM-DD');
            let prevRxItemDuration = parseInt(prescriptionItem?.duration);

            if (prevRxItemStartDate.isSame(prevOrderStartDate) && prevRxItemDuration === prevOrderNoOfDays) {
                updateItem(id,
                    {
                        startDate: newOrderStartDate.format('YYYY-MM-DD'),
                        duration: parseInt(newOrderNoOfDays)
                    }
                );
            }
        }
        return { startDate: newOrderStartDate.format('YYYY-MM-DD'), noOfDays: newOrderNoOfDays, endDate: moment(newOrderStartDate).add(newOrderNoOfDays - 1, 'days').format('YYYY-MM-DD') };
    }

    /**
     * Get Initial Values for the new prescriptionItem
     * @param {*} itemId 
     * @param {*} itemBatchId 
     * @returns 
     */
    function getInitialValuesForNewPrescriptionItem(itemId, itemBatches) {
        let initialValues = {
            orderId: parseInt(orderId),
            prescriptionId: parseInt(orderData?.prescriptionId),
            itemId: parseInt(itemId),
            itemBatches: itemBatches || [],
            time: [],
            meal: [],
            typeOfAdmin: "DAYS",
            sunday: true,
            monday: true,
            tuesday: true,
            wednesday: true,
            thursday: true,
            friday: true,
            saturday: true,
            doseSize: 1,
            startDate: orderData?.startDate,
            duration: orderData?.noOfDays,
            endDate: orderData?.endDate
        }

        return initialValues;
    }

    /**
     * 
     * @param  links updates links 
     */
    function updatePrescription(links) {
        setuserData((prevState) => {
            let newPrescription = { ...prevState.prescription };
            newPrescription.links = links
            return { ...prevState, prescription: newPrescription }
        });
    }


    /**
     * Handle today item click if the item is starting today then it will start from tomorrow
     * @param {*} id 
     */
    function handleTodayItem(id) {
        let item = orderData?.prescriptionItems[id];
        if (item.startDate === moment().format('YYYY-MM-DD') && item.duration > 1) {
            updateItem(id, { startDate: moment().add(1, 'days').format('YYYY-MM-DD'), duration: item.duration - 1 })
        }
    }

    /**
         * Updates The OrderData state which have prescription item order startDate endDate noOfDays drName prscriptionDate
         *
         * @param value Value to be changed
         * @param name name of the key to be changed
     */
    function updateOrderData(value, name) {
        let newOrderData = { ...orderData };
        let payLoadData = {};
        payLoadData[name] = value

        if (name === 'noOfDays' || name === 'startDate') {
            let newData = handleOrderStartDateOrDurationChange(name === 'startDate' ? moment(value, 'YYYY-MM-DD') : null, name === 'noOfDays' ? parseInt(value) : null, orderData);
            payLoadData = newData;
            newOrderData = { ...newOrderData, ...newData }
        } else if (name === 'channel') {
            // Handle source change logic
            newOrderData[name] = value;
            payLoadData[name] = value;

            // If source is INTERNAL, update order type and clear partnerId
            if (value === "INTERNAL") {
                const currentOrderTypeBase = orderData?.type?.replace('PARTNER_', '').replace('INTERNAL_', '') || '';
                if (currentOrderTypeBase) {
                    const newType = `INTERNAL_${currentOrderTypeBase}`;
                    newOrderData['type'] = newType;
                    payLoadData['type'] = newType;
                }
                newOrderData['partnerId'] = null;
                payLoadData['partnerId'] = null;
            }

            // Clear channel when source changes, but only if the current channel
            // is not valid for the new source
            if (orderData?.source && value) {
                const newSourceChannels = getSourcesForChannels(value);
                if (!newSourceChannels.includes(orderData.source)) {
                    newOrderData['source'] = '';
                    payLoadData['source'] = '';
                }
            } else if (!value) {
                // Clear channel if no source is selected
                newOrderData['channel'] = '';
                payLoadData['channel'] = '';
                newOrderData['source'] = '';
                payLoadData['source'] = '';
                newOrderData['partnerId'] = null;
                payLoadData['partnerId'] = null;
            }
        } else if (name === 'cancelWithReason') {
            // Status + reason must travel together: the reason is only meaningful as part
            // of the transition that caused it, and sending them as two PUTs would leave a
            // window where the order is cancelled with no recorded reason.
            newOrderData['status'] = ORDER_CANCELLED;
            // The reason is optional — omit the key when blank so the backend stores null
            // rather than an empty string, keeping "no reason given" distinguishable.
            payLoadData = value
                ? { status: ORDER_CANCELLED, cancelledReason: value }
                : { status: ORDER_CANCELLED };
        } else if (name === 'mrno') {
            const updatedMetadata = { ...(orderData.metadata || {}), mrno: value };
            newOrderData.metadata = updatedMetadata;
            newOrderData.partnerEntityId = value;
            payLoadData = { metadata: updatedMetadata, partnerEntityId: value };
        } else {
            newOrderData[name] = value;
            payLoadData[name] = value;
        }

        setOrderData(newOrderData);

        // Returned, not awaited: every existing caller ignores it, but the cancellation
        // prompt needs something to await so it can disable its buttons while the PUT is
        // in flight.
        if (name == 'drName' || name == 'date') {
            return UpdatePrescription(userData.prescription.id, payLoadData)
        } else {
            return UpdateOrder(payLoadData, orderId)
        }
    }


    /**
          * Updates a specific prescriptionItem 
          *
          * @param id Id of the prescriptionItem to be changed
          * @param value Value to be changed
          * @param keyname name of the key to be changed
      */
    function updateItem(id, data) {
        let prevItem = JSON.parse(JSON.stringify(orderData.prescriptionItems[id]));
        let newItem = JSON.parse(JSON.stringify(orderData.prescriptionItems[id]));
        let payLoadData = {};

        for (let keyname in data) {
            let value = data[keyname];

            if (keyname == 'item') {
                payLoadData['itemId'] = parseInt(value?.id)
            } else if (keyname == 'itemBatch') {
                payLoadData['itemBatchId'] = parseInt(value?.id)
            } else if (keyname == 'itemBatches') {
                payLoadData['itemBatches'] = value;
                // Also set the first batch as itemBatchId for backward compatibility
                if (value && value.length > 0) {
                    payLoadData['itemBatchId'] = parseInt(value[0]?.id);
                } else {
                    payLoadData['itemBatchId'] = null;
                }
            } else {
                payLoadData[keyname] = value;
            }

            if (keyname === 'startDate') {
                newItem['startDate'] = moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD');
                let endDate = moment(newItem['startDate']).add(newItem['duration'] - 1, 'days').format('YYYY-MM-DD')
                newItem['endDate'] = endDate;
                payLoadData['startDate'] = moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD');
                payLoadData['endDate'] = endDate;
            }
            if (keyname === 'duration') {
                let endDate = moment(newItem['startDate']).add(value - 1, 'days').format('YYYY-MM-DD')
                newItem['endDate'] = endDate;
                payLoadData['endDate'] = endDate;
                payLoadData['duration'] = value;
            }
            if (keyname === 'typeOfAdmin' && value === 'DATE') {
                newItem['endDate'] = moment(newItem['startDate']).format('YYYY-MM-DD');
                newItem['duration'] = 1;
                payLoadData['endDate'] = moment(newItem['startDate']).format('YYYY-MM-DD');
                payLoadData['duration'] = 1;
            }
            newItem[keyname] = value;
        }

        setOrderData((prevState) => {
            let prescriptionItems = prevState.prescriptionItems;
            prescriptionItems[id] = newItem;
            return { ...prevState, prescriptionItems: prescriptionItems }
        });
        UpdatePrescriptionItem(id, payLoadData).then((response) => {
            if (!response?.data?.success) {
                setOrderData((prevState) => {
                    let prescriptionItems = prevState.prescriptionItems;
                    prescriptionItems[id] = prevItem;
                    return { ...prevState, prescriptionItems: prescriptionItems }
                });
            }
        });
    }

    /**
        * Add a new prescription Item either duplicate or duplicate with startdate as today
        *
        * @param id Id of the prescriptionItem from which new Item has to be created
        * @param type Either duplicate or today
    */
    function addItem(id, type) {
        let newItem = { ...orderData.prescriptionItems[id] };
        if (type == 'today') {
            newItem.startDate = moment().format();
            newItem.duration = 1;
            newItem.endDate = moment().format();
            handleTodayItem(id);
        }

        // Ensure itemBatches exists in the new item
        if (!newItem.itemBatches && newItem.itemBatchId) {
            // Create itemBatches from the itemBatchId for backward compatibility
            newItem.itemBatches = newItem.itemBatch ? [newItem.itemBatch] :
                (newItem.itemBatchId ? [{ id: newItem.itemBatchId }] : []);
        }

        for (let key in newItem) {
            if (key.includes('Id')) newItem[key] = parseInt(newItem[key]);
            if (isNil(newItem[key])) delete newItem[key];
        }

        delete newItem.id;

        let now = moment().valueOf();

        setOrderData((prevState) => {
            let prescriptionItems = prevState.prescriptionItems;
            prescriptionItems[`${id}:${now}`] = newItem;
            return { ...prevState, prescriptionItems }
        })

        AddPrescriptionItem(newItem).then((response) => {
            if (!response?.data?.success) {
                setOrderData((prevState) => {
                    let prescriptionItems = prevState.prescriptionItems;
                    delete prescriptionItems[`${id}:${now}`];
                    return { ...prevState, prescriptionItems }
                })
            }
            setOrderData((prevState) => {
                let prescriptionItems = prevState.prescriptionItems;
                prescriptionItems[response?.data?.data?.id] = response?.data?.data;
                delete prescriptionItems[`${id}:${now}`];
                return { ...prevState, prescriptionItems }
            })
            scrollToPrescriptionItemById(response?.data?.data?.id);
        });
    }

    /**
         * Add a new fresh prescriptionItem with only name and batch info
         *
         * @param itemId Id of the item is to be added in the prescriptionItem
         * @param itemBatchId Id of the batch of item
    */
    function addNewItem(itemId, itemBatches) {
        let payLoadData = getInitialValuesForNewPrescriptionItem(itemId, itemBatches);
        let now = moment().valueOf();

        setOrderData((prevState) => {
            let prescriptionItems = prevState.prescriptionItems;
            prescriptionItems[`:${now}`] = payLoadData;
            return { ...prevState, prescriptionItems }
        });

        AddPrescriptionItem(payLoadData).then((response) => {
            if (!response?.data?.success) {
                setOrderData((prevState) => {
                    let prescriptionItems = prevState.prescriptionItems;
                    delete prescriptionItems[`:${now}`];
                    return { ...prevState, prescriptionItems }
                })
            }
            setOrderData((prevState) => {
                let prescriptionItems = prevState.prescriptionItems;
                prescriptionItems[response?.data?.data?.id] = response?.data?.data;
                delete prescriptionItems[`:${now}`];
                return { ...prevState, prescriptionItems: prescriptionItems }
            })
            scrollToPrescriptionItemById(response?.data?.data?.id);
        });
    }
    /**
        * Deletes a PrescriptionItem
        *
        * @param id id of the Prescription Item is to be deleted
        * @param itemBatchId Id of the batch of item
    */
    function deleteItem(id) {
        setOrderData((prevState) => {
            let prescriptionItems = prevState.prescriptionItems;
            delete prescriptionItems[id];
            return { ...prevState, prescriptionItems }
        })
        DeletePrescriptionItem(id);
    }

    return (
        <div className='py-3 px-5 flex flex-col gap-3 relative h-full overflow-y-scroll' >
            <div className='flex justify-start' >
                <button onClick={handleBackClick} className='font-bold text-[15px]' >
                    <FontAwesomeIcon icon={faChevronLeft} />
                    Go Back
                </button>
            </div>

            {(data?.data?.data && userData !== null) && <Header isFullyPaid={orderData.isFullyPaid} userData={userData} addNewItem={addNewItem} updatePrescription={updatePrescription} refetch={refetch} quotationId={orderData.quotationId} orderData={orderData} />}
            {orderData !== null && isPillupTenant && (
                <RefundsTable
                    refunds={refunds}
                    isLoading={refundsLoading}
                />
            )}
            {orderData !== null && isPillupTenant && <PaymentsTable payments={orderData.payments} orderTotal={orderData.total} paymentItems={orderData.paymentItems} isFullyPaid={orderData.isFullyPaid} totalPayments={orderData.totalPayments} refetch={refetch} />}
            {orderData !== null && isPillupTenant && <PaymentsItemsTable paymentItems={orderData.paymentItems} refetch={refetch} orderId={orderId} quotationId={orderData.quotationId} orderData={orderData} />}
            {orderData !== null && isPillupTenant && <ItemSubstitutes
                itemSubstitutes={orderData.itemSubstitutes}
                quotationId={orderData.quotationId}
                orderId={orderId}
                prescriptionItems={orderData.prescriptionItems}
                onRefetch={refetch}
                isEditable={orderData.isEditable}
            />}
            {(orderData !== null) && <MainFields orderType={orderData.type} chronicity={orderData.chronicity} partnerId={orderData.partnerId} status={orderData.status} messages={orderData?.messages} updateOrderData={updateOrderData} startDate={orderData.startDate} noOfDays={orderData.noOfDays} drName={orderData.drName} prescriptionDate={orderData.date} endDate={orderData.endDate} userNotes={orderData.notes} source={orderData.source} channel={orderData.channel} isEditable={orderData.isEditable} partners={partners} partnersLoading={partnersLoading} isEazy={tenantId === TENANT_COMPANY_MAP.EAZY} mrno={orderData.metadata?.mrno} paymentStatus={orderData.metadata?.paymentStatus} inventoryId={orderData.inventoryId} billNumber={orderData.additionalDetails?.billNumber} onFetchBillNumber={tenantId !== TENANT_COMPANY_MAP.EAZY ? fetchBillNumber : null} />}
            {orderData !== null && isPillupTenant && <DrugInteractionPanel orderId={orderId} />}
            {orderData !== null && isPillupTenant && <PreShipmentChecklist orderId={orderId} />}
            {orderData !== null && <OrderHistory orderId={orderId} />}
            {orderData !== null && isPillupTenant && <InvoiceRxCheckPanel additionalDetails={orderData.additionalDetails} onRefresh={refetch} />}
            {orderData !== null && <PrescriptionItems order={orderData} addItem={addItem} deleteItem={deleteItem} updateItem={updateItem} Items={orderData.prescriptionItems} refetch={refetch} />}
            <Footer addNewItem={addNewItem} />
            <div className="flex items-center justify-between gap-2 mt-4 p-4 bg-[#069079] rounded-xl shadow">
                <div>
                    <div className="text-sm text-gray-100 font-medium">Order Total</div>
                    <div className="text-2xl font-semibold text-white-50">
                        {orderData?.total?.toLocaleString('en-IN', {
                            style: 'currency',
                            currency: 'INR',
                            minimumFractionDigits: 2,
                        })}
                    </div>
                </div>
                {orderData && userData && !isEasydose && (
                    <OrderScreenshot
                        orderId={orderId}
                        orderData={orderData}
                        userData={userData}
                    />
                )}
            </div>
        </div >
    )
}
